export default {
  function: (state, data) => data(state),
};
